/* ============================================================
   DESIGN BY CHAZ — THEME JS  v4
   ============================================================ */

'use strict';

/* ── Cart State ────────────────────────────────────────────── */
let cartState = { items: [], item_count: 0, total_price: 0 };
let selectedVariantId = null;

/* ── Init ──────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function () {
  initLazyImages();
  if (document.getElementById('cart-drawer')) fetchCartState();

  // Set initial selected variant
  const hiddenVariant = document.getElementById('selected-variant-id');
  if (hiddenVariant) selectedVariantId = hiddenVariant.value;

  const firstVariantBtn = document.querySelector('.variant-btn.selected[data-variant-id]');
  if (firstVariantBtn) selectedVariantId = firstVariantBtn.dataset.variantId;
  const formVariant = document.getElementById('product-form-variant');
  if (formVariant && formVariant.value) selectedVariantId = formVariant.value;

  // Track + render recently viewed
  if (window.productData) {
    trackRecentlyViewed(window.productData);
    renderRecentlyViewed();
  }

  // Email popup

  // Countdown timers (password page + optional homepage)
  initCountdowns();
});

/* ── Lazy Images ───────────────────────────────────────────── */
function initLazyImages() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('img.lazy').forEach(function (img) {
      if (img.dataset.src) { img.src = img.dataset.src; img.classList.add('loaded'); img.classList.remove('lazy'); }
    });
    return;
  }
  const obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      const img = entry.target;
      if (img.dataset.src) {
        img.src = img.dataset.src;
        img.classList.add('loaded');
        img.classList.remove('lazy');
        obs.unobserve(img);
      }
    });
  }, { rootMargin: '200px' });
  document.querySelectorAll('img.lazy').forEach(function (img) { obs.observe(img); });
}

/* ── Mobile Menu ───────────────────────────────────────────── */
function toggleMobileMenu() {
  const overlay = document.getElementById('mobile-menu-overlay');
  const hamburger = document.querySelector('.hamburger');
  const isOpen = overlay.classList.contains('is-open');
  if (isOpen) {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
  } else {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
  }
}

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  const mobileOverlay = document.getElementById('mobile-menu-overlay');
  if (mobileOverlay && mobileOverlay.classList.contains('is-open')) toggleMobileMenu();
  closeCartDrawer();
});

/* ── Cart Drawer ───────────────────────────────────────────── */
function openCartDrawer() {
  fetchCartState().then(function () { renderCartDrawer(); });
  document.getElementById('cart-drawer').classList.add('is-open');
  document.getElementById('cart-drawer-overlay').classList.add('is-open');
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-drawer-overlay');
  if (drawer) drawer.classList.remove('is-open');
  if (overlay) overlay.classList.remove('is-open');
  document.body.style.overflow = '';
}

function fetchCartState() {
  return fetch(dbcRoute('cart.js'), { headers: { 'Content-Type': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      cartState = cart;
      updateCartCounts(cart.item_count);
      return cart;
    })
    .catch(function (err) { console.error('Cart fetch:', err); });
}

function updateCartCounts(count) {
  document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = count; });
  document.querySelectorAll('.desktop-topbar .topbar-checkout').forEach(function (el) { el.hidden = !count; });
}

function addCrosssell(variantId) {
  if (!variantId) return;
  fetch(dbcRoute('cart/add.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function (r) { return r.json(); })
    .then(function () { fetchCartState().then(renderCartDrawer); })
    .catch(function (err) { console.error('Cross-sell add:', err); });
}

function updateCartItem(key, quantity) {
  fetch(dbcRoute('cart/change.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      cartState = cart;
      updateCartCounts(cart.item_count);
      renderCartDrawer();
    })
    .catch(function (err) { console.error('Cart update:', err); });
}

/* ── Add to Cart ───────────────────────────────────────────── */
function addToCart() {
  const btn = document.getElementById('add-to-cart-btn');
  if (!btn) return;
  const variantId = selectedVariantId || btn.dataset.variantId;
  if (!variantId) return;
  const qty = 1;

  btn.textContent = 'ADDING...';
  btn.classList.add('loading');

  fetch(dbcRoute('cart/add.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
    .then(function (r) { if (!r.ok) throw new Error('Failed'); return r.json(); })
    .then(function () {
      btn.textContent = 'ADDED';
      setTimeout(function () {
        btn.textContent = 'ADD TO CART';
        btn.classList.remove('loading');
      }, 1200);
      openCartDrawer();
    })
    .catch(function (err) {
      console.error('Add to cart:', err);
      btn.textContent = 'ERROR. TRY AGAIN';
      btn.classList.remove('loading');
      setTimeout(function () { btn.textContent = 'ADD TO CART'; }, 2000);
    });
}

/* ── Variant Selection ─────────────────────────────────────── */
function selectVariant(btn) {
  if (btn.dataset.available === 'false') return;
  document.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  selectedVariantId = btn.dataset.variantId;
  const priceEl = document.getElementById('product-price');
  if (priceEl && btn.dataset.price) priceEl.textContent = formatMoney(parseInt(btn.dataset.price, 10));
  const atcBtn = document.getElementById('add-to-cart-btn');
  if (atcBtn) atcBtn.dataset.variantId = selectedVariantId;
}

/* ── Product Gallery ───────────────────────────────────────── */
function switchProductImage(thumb) {
  /* Takes a thumbnail, or an image URL from a variant's featured image. */
  const mainImg = document.getElementById('product-main-img');
  if (!mainImg) return;
  const thumbs = [].slice.call(document.querySelectorAll('.product-page__thumb'));
  if (!mainImg.dataset.first) {
    mainImg.dataset.first = thumbs.length ? thumbs[0].dataset.full : mainImg.getAttribute('src');
    mainImg.dataset.firstSrcset = mainImg.getAttribute('srcset') || '';
  }
  let url = null;
  if (typeof thumb === 'string') {
    url = thumb;
    thumb = thumbs.filter(function (t) { return t.dataset.full === url; })[0] || null;
  } else if (thumb) {
    url = thumb.dataset.full;
  }
  if (!url) return;
  /* srcset wins over src, so it has to follow the swap. A variant image with no
     thumbnail gets the plain 1000px src. */
  let srcset = '';
  if (thumb) srcset = thumb.dataset.srcset || '';
  else if (url === mainImg.dataset.first) srcset = mainImg.dataset.firstSrcset || '';
  if ((mainImg.getAttribute('srcset') || '') !== srcset) {
    if (srcset) mainImg.setAttribute('srcset', srcset);
    else mainImg.removeAttribute('srcset');
  }
  if (mainImg.getAttribute('src') !== url) mainImg.src = url;
  thumbs.forEach(function (t) { t.classList.toggle('active', t === thumb); });
  // The lit layer only matches the first shot, so hide it once another angle is chosen.
  var wrap = document.querySelector('.product-page__main-img-wrap.has-lit');
  if (wrap) wrap.classList.toggle('is-swapped', thumb ? thumbs.indexOf(thumb) > 0 : url !== mainImg.dataset.first);
}

/* ── light the lamp on touch screens when it reaches the middle of the view ── */
function initLitOnScroll() {
  if (!('IntersectionObserver' in window)) return;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (fine) return; // desktop already lights on hover
  var targets = document.querySelectorAll('[data-lit]');
  if (!targets.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      e.target.classList.toggle('is-lit', e.isIntersecting);
    });
  }, { rootMargin: '-40% 0px -40% 0px', threshold: 0 });
  targets.forEach(function (t) { io.observe(t); });
}
document.addEventListener('DOMContentLoaded', initLitOnScroll);

/* ── Recently Viewed ───────────────────────────────────────── */
var RV_KEY = 'dbc_recently_viewed';
var RV_MAX = 10;

function trackRecentlyViewed(product) {
  try {
    var existing = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
    // Remove current product if already stored
    existing = existing.filter(function (p) { return p.id !== product.id; });
    // Prepend current
    existing.unshift({
      id: product.id,
      handle: product.handle,
      title: product.title,
      price: product.price,
      image: product.image,
      url: product.url
    });
    // Cap at max
    existing = existing.slice(0, RV_MAX);
    localStorage.setItem(RV_KEY, JSON.stringify(existing));
  } catch (e) {
    // localStorage blocked — silently skip
  }
}

function renderRecentlyViewed() {
  var container = document.getElementById('recently-viewed');
  var grid = document.getElementById('recently-viewed-grid');
  if (!container || !grid) return;

  var currentId = parseInt(container.dataset.current, 10);

  try {
    var products = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
    // Exclude current product, take up to 3
    var toShow = products.filter(function (p) { return p.id !== currentId; }).slice(0, 3);
    if (toShow.length === 0) return;

    var html = toShow.map(function (p) {
      return `
        <div class="product-grid__item">
          <a href="${p.url}" class="product-card">
            <div class="product-card__media">
              ${p.image
                ? `<img src="${p.image}" alt="${escapeHtml(p.title)}" class="product-card__img lazy" data-src="${p.image}" width="400" height="400" loading="lazy">`
                : `<div style="width:100%;aspect-ratio:1/1;background:#0d0d0d;"></div>`
              }
            </div>
            <div class="product-card__info">
              <h2 class="product-card__title">${p.title.toUpperCase()}</h2>
              <div class="product-card__price">${formatMoney(p.price)}</div>
            </div>
          </a>
        </div>`;
    }).join('');

    grid.innerHTML = html;
    container.style.display = 'block';
    initLazyImages();
  } catch (e) {
    // localStorage blocked — silently skip
  }
}


/* ── Countdown Timer ───────────────────────────────────────── */
function initCountdowns() {
  var cfg = window.dbcTheme || {};
  var targetStr = cfg.countdownDate;

  // Also check password page data attribute
  var pwEl = document.getElementById('countdown-timer');
  if (pwEl && pwEl.dataset.date) targetStr = pwEl.dataset.date;

  if (!targetStr) return;

  /* UK wall clock time ("2026-10-25 20:00") or ISO with offset. See dbcParseDropDate. */
  var target = dbcParseDropDate(targetStr);
  if (isNaN(target)) return;

  function tick() {
    var now = Date.now();
    var diff = target - now;

    if (diff <= 0) {
      setCountdownDisplay(0, 0, 0, 0);
      return;
    }

    var days  = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var mins  = Math.floor((diff % 3600000) / 60000);
    var secs  = Math.floor((diff % 60000) / 1000);

    setCountdownDisplay(days, hours, mins, secs);
    setTimeout(tick, 1000);
  }

  tick();
}

function setCountdownDisplay(days, hours, mins, secs) {
  function pad(n) { return String(n).padStart(2, '0'); }
  var els = {
    days:  document.getElementById('cd-days'),
    hours: document.getElementById('cd-hours'),
    mins:  document.getElementById('cd-mins'),
    secs:  document.getElementById('cd-secs')
  };
  if (els.days)  els.days.textContent  = pad(days);
  if (els.hours) els.hours.textContent = pad(hours);
  if (els.mins)  els.mins.textContent  = pad(mins);
  if (els.secs)  els.secs.textContent  = pad(secs);

  // Homepage countdown (optional separate element)
  var hpDays  = document.getElementById('hp-cd-days');
  var hpHours = document.getElementById('hp-cd-hours');
  var hpMins  = document.getElementById('hp-cd-mins');
  var hpSecs  = document.getElementById('hp-cd-secs');
  if (hpDays)  hpDays.textContent  = pad(days);
  if (hpHours) hpHours.textContent = pad(hours);
  if (hpMins)  hpMins.textContent  = pad(mins);
  if (hpSecs)  hpSecs.textContent  = pad(secs);
}

/* ── Cookie Helpers ────────────────────────────────────────── */
function setCookie(name, value, days) {
  var expires = '';
  if (days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + d.toUTCString();
  }
  document.cookie = name + '=' + value + expires + '; path=/; SameSite=Lax';
}

function getCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

/* ── Utilities ─────────────────────────────────────────────── */
function formatMoney(cents, currency) {
  /* Cart and product JSON arrive already in the market's currency; this only formats. */
  currency = currency || dbcCfg().currency || 'GBP';
  var amount = Number(cents) / 100;
  if (!Number.isFinite(amount)) return '';
  try {
    return new Intl.NumberFormat(dbcCfg().locale || 'en', { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol' }).format(amount);
  } catch (e) { return currency + ' ' + amount.toFixed(2); }
}
/* Markets can serve the store under a market subfolder; cart endpoints must stay inside it. */
function dbcRoute(path) { return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || dbcCfg().root || '/') + path.replace(/^\//, ''); }
/* Back/forward cache: a restored page keeps its old cart count, so refetch the cart
   instead of reloading (a reload throws the cache away and makes Back slow on phones).
   Only reload when the market changed meanwhile, because then the prices are stale. */
window.addEventListener('pageshow', function (e) {
  if (!e.persisted) return;
  var p = fetchCartState();
  if (p && p.then) p.then(function (cart) {
    var cur = dbcCfg().currency;
    if (cart && cart.currency && cur && cart.currency !== cur) window.location.reload();
  });
});

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

/* ============================================================
   v23 — CONVERSION ADDITIONS
   Klaviyo phone/email capture, popup, sticky add to cart, quick add,
   bundle builder, cart drawer upgrades, the street stage, countdowns.
   Later declarations override the v4 ones above on purpose.
   ============================================================ */

/* ── helpers ─────────────────────────────────────────────── */
function dbcCfg() { return window.dbcTheme || {}; }
function dbcMoneyClean(cents) { return formatMoney(cents).replace(/\.00$/, ''); }
function dbcSized(url, w) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
function dbcToast(msg) {
  var el = document.getElementById('dbc-toast');
  if (!el) { el = document.createElement('div'); el.id = 'dbc-toast'; el.setAttribute('role', 'status'); el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:900;background:#fff;color:#000;padding:10px 16px;font-size:1rem;font-weight:700;letter-spacing:.1em;opacity:0;transition:opacity .2s;pointer-events:none;white-space:nowrap;max-width:calc(100% - 32px);overflow:hidden;text-overflow:ellipsis'; document.body.appendChild(el); }
  el.textContent = msg; el.style.opacity = '1'; clearTimeout(el._t); el._t = setTimeout(function () { el.style.opacity = '0'; }, 2600);
}

/* ── cart: add items (array) then open drawer ─────────────── */
function dbcCartAdd(items) {
  return fetch(dbcRoute('cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
    .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
    .then(function () { return fetchCartState(); })
    .then(function () { renderCartDrawer(); openCartDrawer(); });
}

/* ── add to cart (product page + sticky bar) ──────────────── */
function addToCart(btn) {
  btn = btn || document.getElementById('add-to-cart-btn');
  if (!btn || btn.disabled) return;
  /* The form's hidden id input is the source of truth; the dynamic checkout button reads it too. */
  var variantId = (document.getElementById('product-form-variant') || {}).value || selectedVariantId || btn.dataset.variantId;
  if (!variantId) return;
  var label = btn.textContent;
  btn.textContent = 'ADDING...'; btn.classList.add('loading');
  dbcCartAdd([{ id: parseInt(variantId, 10), quantity: 1 }])
    .then(function () { btn.textContent = 'ADDED'; setTimeout(function () { btn.textContent = 'ADD TO CART'; btn.classList.remove('loading'); }, 1200); })
    .catch(function (err) { btn.textContent = 'TRY AGAIN'; btn.classList.remove('loading'); dbcToast((err && err.description) || 'COULD NOT ADD'); setTimeout(function () { btn.textContent = label; }, 2000); });
}

/* ── variant picker: one chip row per option ──────────────
   Chips carry data-option-index + data-value. The chosen values map to a
   variant in #product-variant-data. Option 1 chips grey out only when every
   variant with that value is sold out; later rows grey out per combination with
   the rows above. Choosing a value whose combination is sold out moves the
   later rows to the nearest available variant. */
function dbcVariants() {
  if (window.dbcVariantList) return window.dbcVariantList;
  var el = document.getElementById('product-variant-data');
  try { window.dbcVariantList = el ? JSON.parse(el.textContent) : []; } catch (e) { window.dbcVariantList = []; }
  return window.dbcVariantList;
}
function dbcPickerValues(picker) {
  var sel = [];
  picker.querySelectorAll('.variant-group').forEach(function (g, i) {
    var on = g.querySelector('.variant-btn[aria-pressed="true"]');
    sel[i] = on ? on.getAttribute('data-value') : null;
  });
  return sel;
}
function dbcFindVariant(sel) {
  return dbcVariants().filter(function (v) { return sel.every(function (val, i) { return v.options[i] === val; }); })[0] || null;
}
function dbcBestVariant(sel, idx) {
  /* Available variant that keeps rows 0..idx, then as many later rows as possible. */
  var best = null, bestScore = -1;
  dbcVariants().forEach(function (v) {
    if (!v.available) return;
    for (var i = 0; i <= idx; i++) if (v.options[i] !== sel[i]) return;
    var score = 0;
    for (var j = idx + 1; j < sel.length; j++) if (v.options[j] === sel[j]) score += Math.pow(2, sel.length - j);
    if (score > bestScore) { best = v; bestScore = score; }
  });
  return best;
}
function dbcRefreshPicker(picker, sel) {
  var variants = dbcVariants();
  picker.querySelectorAll('.variant-group').forEach(function (g, i) {
    g.querySelectorAll('.variant-btn').forEach(function (b) {
      var val = b.getAttribute('data-value');
      var on = sel[i] === val;
      var open = variants.some(function (v) {
        if (!v.available || v.options[i] !== val) return false;
        for (var k = 0; k < i; k++) if (v.options[k] !== sel[k]) return false;
        return true;
      });
      b.classList.toggle('selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('sold-out', !open);
      if (open) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true');
      var sr = b.querySelector('[data-sold-label]'); if (sr) sr.hidden = open;
    });
  });
}
function dbcApplyVariant(variant, opts) {
  opts = opts || {};
  var ok = !!(variant && variant.available);
  if (variant) {
    selectedVariantId = String(variant.id);
    var formVar = document.getElementById('product-form-variant'); if (formVar) formVar.value = variant.id;
    var price = formatMoney(variant.price);
    var priceEl = document.getElementById('product-price'); if (priceEl && priceEl.textContent !== price) priceEl.textContent = price;
    var sticky = document.querySelector('[data-sticky-price]'); if (sticky) sticky.textContent = price;
  }
  var form = document.getElementById('product-form');
  if (form) { if (ok) form.removeAttribute('data-unavailable'); else form.setAttribute('data-unavailable', ''); }
  [document.getElementById('add-to-cart-btn'), document.querySelector('[data-sticky-atc]')].forEach(function (b) {
    if (!b) return;
    if (variant) b.dataset.variantId = variant.id;
    b.disabled = !ok;
    b.classList.remove('loading');
    b.textContent = ok ? 'ADD TO CART' : 'SOLD OUT';
  });
  var low = document.getElementById('product-low-stock');
  if (low) {
    var n = variant && variant.available ? (variant.low || 0) : 0;
    var q = low.querySelector('[data-low-qty]'); if (q) q.textContent = n || '';
    low.hidden = !n;
  }
  if (variant && variant.image) switchProductImage(variant.image);
  if (variant && opts.url) {
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', variant.id);
      window.history.replaceState(window.history.state, '', u.toString());
    } catch (e) {}
  }
}
function selectVariant(btn) {
  if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
  var picker = btn.closest('[data-variant-picker]');
  if (!picker) return;
  var idx = parseInt(btn.getAttribute('data-option-index'), 10);
  var sel = dbcPickerValues(picker);
  sel[idx] = btn.getAttribute('data-value');
  var variant = dbcFindVariant(sel);
  if (!variant || !variant.available) {
    var best = dbcBestVariant(sel, idx);
    if (best) { variant = best; sel = best.options.slice(); }
  }
  dbcRefreshPicker(picker, sel);
  dbcApplyVariant(variant, { url: true });
}
(function () {
  var picker = document.querySelector('[data-variant-picker]'); if (!picker) return;
  var sel = dbcPickerValues(picker);
  dbcRefreshPicker(picker, sel);
  var variant = dbcFindVariant(sel);
  /* Server render already matches the variant; only fix up states the markup can't know. */
  if (variant && !variant.available) dbcApplyVariant(variant);
  else if (variant) {
    var form = document.getElementById('product-form'); if (form) form.removeAttribute('data-unavailable');
    if (variant.image) switchProductImage(variant.image);
  }
})();

/* ── cart drawer: ship bar, upsells, bundle hint ──────────── */
function renderCartDrawer() {
  var itemsEl = document.getElementById('cart-drawer-items');
  var subtotalEl = document.getElementById('cart-drawer-subtotal');
  var upsellEl = document.getElementById('cart-upsell-prompt');
  if (!itemsEl) return;
  var cfg = dbcCfg();
  var cart = cartState;

  if (!cart || cart.item_count === 0) {
    itemsEl.innerHTML = '<div class="cart-drawer__empty">YOUR CART IS EMPTY.</div>';
    if (subtotalEl) subtotalEl.textContent = '—';
    if (upsellEl) upsellEl.innerHTML = dbcUpsellHtml(cart, true);
    var protEmpty = document.getElementById('cart-protection'); if (protEmpty) protEmpty.innerHTML = ''; /* nothing to protect */
    var discEmpty = document.getElementById('cart-discount'); if (discEmpty) discEmpty.innerHTML = '';
    return;
  }
  var html = '';
  var prot = cfg.protection || null;
  var protLine = prot ? cart.items.filter(function (it) { return it.product_id === prot.id; })[0] : null;
  /* If protection is the only thing left, it is not a cart. Drop it and show empty. */
  if (protLine && cart.items.length === 1) { updateCartItem(protLine.key, 0); return; }
  var ship = dbcShipTarget(cart, protLine);
  /* Tees always ship free: a tee only cart says so instead of counting towards a threshold. */
  var teeIds = {}; (cfg.dropPair || []).forEach(function (p) { if (p.type === 'Tee') teeIds[p.id] = true; });
  var paid = cart.items.filter(function (it) { return !(prot && it.product_id === prot.id) && !teeIds[it.product_id]; });
  if (!paid.length) {
    html += '<div class="ship-bar is-done"><div class="ship-bar__txt">TEES SHIP FREE</div><div class="ship-bar__track"><div class="ship-bar__fill" style="width:100%"></div></div></div>';
  } else if (ship) {
    var done = ship.sub >= ship.th, pct = Math.min(100, Math.round(ship.sub / ship.th * 100));
    html += '<div class="ship-bar' + (done ? ' is-done' : '') + '"><div class="ship-bar__txt">' + (done ? ship.label + ' UNLOCKED' : '<strong>' + dbcMoneyClean(ship.th - ship.sub) + '</strong> AWAY FROM ' + ship.label) + '</div><div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div></div>';
  }
  /* Gymshark does this well: say it plainly, once, above the items. */
  html += '<div class="cart-reserve"><span class="cart-reserve__i" aria-hidden="true">i</span>NOTHING IN YOUR CART IS RESERVED. CHECK OUT TO LOCK IT IN.</div>';
  cart.items.forEach(function (item) {
    if (prot && item.product_id === prot.id) return; /* rendered as the toggle below, not as a line */
    var imgSrc = item.image ? dbcSized(item.image, 140) : '';
    html += '<div class="cart-item" data-key="' + item.key + '">' +
      '<a href="' + item.url + '">' + (imgSrc ? '<img class="cart-item__img" src="' + imgSrc + '" alt="" width="70" height="70">' : '<div class="cart-item__img" style="background:#0d0d0d;"></div>') + '</a>' +
      '<div class="cart-item__details"><a href="' + item.url + '" class="cart-item__title">' + escapeHtml(item.product_title.toUpperCase()) + '</a>' +
      (item.variant_title && item.variant_title !== 'Default Title' ? '<span class="cart-item__variant">' + escapeHtml(item.variant_title.toUpperCase()) + '</span>' : '') +
      '<div class="cart-item__qty"><button class="cart-item__qty-btn" onclick="updateCartItem(\'' + item.key + '\', ' + (item.quantity - 1) + ')" aria-label="Decrease">−</button><span class="cart-item__qty-value">' + item.quantity + '</span><button class="cart-item__qty-btn" onclick="updateCartItem(\'' + item.key + '\', ' + (item.quantity + 1) + ')" aria-label="Increase">+</button></div>' +
      '<button class="cart-item__remove" onclick="updateCartItem(\'' + item.key + '\', 0)">REMOVE</button></div>' +
      '<div class="cart-item__price">' + formatMoney(item.final_line_price) + (item.original_line_price > item.final_line_price ? '<br><s style="color:#444;font-weight:400;font-size:.85rem">' + formatMoney(item.original_line_price) + '</s>' : '') + '</div></div>';
  });
  itemsEl.innerHTML = html;
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  /* The drop pairing replaces the generic upsells while it applies. */
  var pairHtml = dbcPairHtml(cart);
  if (upsellEl) upsellEl.innerHTML = dbcBundleHintHtml(cart) + (pairHtml || dbcUpsellHtml(cart, false));
  var protEl = document.getElementById('cart-protection');
  if (protEl) protEl.innerHTML = prot ? dbcProtectionHtml(prot, !!protLine) : '';
  var discEl = document.getElementById('cart-discount');
  if (discEl) discEl.innerHTML = ''; /* DBC never runs codes: no code box in the drawer. Gift cards still go in at checkout. */
}

/* ── free shipping target by market ───────────────────────── */
/* Thresholds live in window.dbcTheme.freeShippingBy and mirror Settings > Shipping.
   Decks are in their own shipping profile, so their subtotal is tracked apart:
   the bar follows everything that is not a deck, and only follows decks when
   the cart is decks alone in the UK. Protection never counts, it would buy its own discount. */
function dbcShipTarget(cart, protLine) {
  var cfg = dbcCfg(), by = cfg.freeShippingBy || {}, cc = String(cfg.country || 'GB').toUpperCase();
  var zone = cc === 'GB' ? 'GB' : cc === 'AU' ? 'AU' : (cfg.euCodes || []).indexOf(cc) > -1 ? 'EU' : 'ROW';
  /* Protection never counts. Everything else does: Shopify checks the free shipping
     threshold against the whole cart, tees included (tested 21 Oct: rug alone £4.99 UK,
     rug plus tee £0). */
  var sub = 0;
  cart.items.forEach(function (it) { if (!(protLine && it.key === protLine.key)) sub += it.final_line_price; });
  var label = { GB: 'FREE UK SHIPPING', AU: 'FREE SHIPPING TO AUSTRALIA', EU: 'FREE EU SHIPPING', ROW: 'FREE SHIPPING' }[zone];
  /* Thresholds are set in GBP. The cart is in the market's currency, so scale the threshold by Shopify's live rate. */
  var rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
  if (sub > 0 && by[zone]) return { sub: sub, th: Math.round(by[zone] * rate), label: label };
  return null;
}

/* Cart page: same bar as the drawer, rendered once on load. */
function dbcRenderCartPageBar() {
  var el = document.getElementById('cart-page-shipbar'); if (!el) return;
  fetchCartState().then(function (cart) {
    if (!cart || !cart.item_count) { el.innerHTML = ''; return; }
    var prot = dbcCfg().protection, protLine = prot ? cart.items.filter(function (it) { return it.product_id === prot.id; })[0] : null;
    var ship = dbcShipTarget(cart, protLine); if (!ship) { el.innerHTML = ''; return; }
    var done = ship.sub >= ship.th, pct = Math.min(100, Math.round(ship.sub / ship.th * 100));
    el.innerHTML = '<div class="ship-bar' + (done ? ' is-done' : '') + '"><div class="ship-bar__txt">' + (done ? ship.label + ' UNLOCKED' : '<strong>' + dbcMoneyClean(ship.th - ship.sub) + '</strong> AWAY FROM ' + ship.label) + '</div><div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div></div>';
  });
}
document.addEventListener('DOMContentLoaded', dbcRenderCartPageBar);

/* Shipping lines are written in GBP. In another market, show the same amount in that currency. */
function dbcLocaliseGbp() {
  var cur = dbcCfg().currency, rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
  if (!cur || cur === 'GBP' || !rate) return;
  document.querySelectorAll('[data-gbp]').forEach(function (el) {
    var pence = parseInt(el.getAttribute('data-gbp'), 10); if (!pence) return;
    /* Thresholds round to whole units (checkout shows Shopify's own converted figure); prices keep pence. */
    var local = pence * rate, whole = pence % 100 === 0;
    el.textContent = formatMoney(whole ? Math.round(local / 100) * 100 : Math.round(local), cur).replace(/\.00$/, '');
  });
}
document.addEventListener('DOMContentLoaded', dbcLocaliseGbp);

/* ── shipping protection toggle ───────────────────────────── */
function dbcProtectionHtml(prot, on) {
  return '<label class="cart-protect' + (on ? ' is-on' : '') + '">' +
    '<input type="checkbox" class="cart-protect__box"' + (on ? ' checked' : '') + ' onchange="toggleProtection(this.checked)">' +
    '<span class="cart-protect__tick" aria-hidden="true"></span>' +
    '<span class="cart-protect__body"><span class="cart-protect__title">SHIPPING PROTECTION <strong>' + dbcMoneyClean(prot.price) + '</strong></span>' +
    '<span class="cart-protect__desc">Lost, stolen or damaged in transit and we send a new one. No claim forms.</span></span>' +
    '</label>';
}

function toggleProtection(on) {
  var prot = dbcCfg().protection; if (!prot || !cartState) return;
  var line = cartState.items.filter(function (it) { return it.product_id === prot.id; })[0];
  document.querySelectorAll('.cart-protect__box').forEach(function (b) { b.disabled = true; });
  if (on && !line) {
    fetch(dbcRoute('cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: prot.variant, quantity: 1 }) })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCartState(); })
      .then(renderCartDrawer)
      .catch(function (err) { console.error('Protection add:', err); renderCartDrawer(); });
  } else if (!on && line) {
    updateCartItem(line.key, 0);
  } else {
    renderCartDrawer();
  }
}

/* ── discount code in the drawer ──────────────────────────── */
var dbcDiscountMsg = '';
function dbcDiscountHtml(cart) {
  var codes = (cart && cart.discount_codes) || [];
  var live = codes.filter(function (c) { return c.applicable; });
  var html = '<div class="cart-discount">';
  if (live.length) {
    dbcDiscountMsg = ''; /* a code that failed on an earlier cart can start working once the right item lands */
    var saved = cart.total_discount || 0;
    html += '<div class="cart-discount__applied"><span class="cart-discount__code">' + escapeHtml(live[0].code.toUpperCase()) + '</span>' +
      (saved ? '<span class="cart-discount__saved">−' + formatMoney(saved) + '</span>' : '') +
      '<button type="button" class="cart-discount__remove" onclick="removeCartDiscount()" aria-label="Remove discount">&#10005;</button></div>';
  } else {
    html += '<form class="cart-discount__form" onsubmit="applyCartDiscount(event)">' +
      '<input class="cart-discount__input" type="text" name="discount" placeholder="DISCOUNT CODE" autocomplete="off" autocapitalize="characters" spellcheck="false" aria-label="Discount code">' +
      '<button type="submit" class="cart-discount__btn">APPLY</button></form>';
  }
  if (dbcDiscountMsg) html += '<div class="cart-discount__msg">' + escapeHtml(dbcDiscountMsg) + '</div>';
  html += '<div class="cart-discount__hint">GIFT CARDS GO IN AT CHECKOUT.</div></div>';
  return html;
}

function applyCartDiscount(ev) {
  ev.preventDefault();
  var input = ev.target.querySelector('.cart-discount__input');
  var code = (input.value || '').trim().toUpperCase();
  if (!code) { input.focus(); return; }
  ev.target.querySelector('.cart-discount__btn').disabled = true;
  fetch(dbcRoute('cart/update.js'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: code }) })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      cartState = cart;
      var hit = (cart.discount_codes || []).filter(function (c) { return c.code.toUpperCase() === code; })[0];
      if (hit && hit.applicable) dbcDiscountMsg = '';
      else if (hit) dbcDiscountMsg = code + " DOESN'T APPLY TO ANYTHING IN THIS CART.";
      else dbcDiscountMsg = "THAT CODE DIDN'T WORK. CHECK THE SPELLING.";
      renderCartDrawer();
    })
    .catch(function (err) { console.error('Discount:', err); dbcDiscountMsg = 'COULD NOT APPLY THAT CODE. TRY AGAIN.'; renderCartDrawer(); });
}

function removeCartDiscount() {
  fetch(dbcRoute('cart/update.js'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) })
    .then(function (r) { return r.json(); })
    .then(function (cart) { cartState = cart; dbcDiscountMsg = ''; renderCartDrawer(); })
    .catch(function (err) { console.error('Discount remove:', err); renderCartDrawer(); });
}

function dbcBundleHintHtml(cart) {
  var b = dbcCfg().bundle; if (!b || !b.handles || !b.handles.length) return '';
  var decks = 0; cart.items.forEach(function (it) { if (b.handles.indexOf(it.handle) > -1) decks += it.quantity; });
  if (!decks) return '';
  var next = decks < 4 ? decks + 1 : null;
  var txt = decks >= 2
    ? '<strong>' + decks + ' DECKS</strong>. BUNDLE PRICE APPLIED' + (next && b.prices[next] ? '. ADD ONE MORE FOR <strong>£' + b.prices[next] + ' TOTAL</strong>' : '')
    : 'ADD A SECOND DECK FOR <strong>£' + b.prices[2] + ' TOTAL</strong>. ANY COLOURWAYS';
  return '<div class="cart-upsell cart-upsell--hint"><div class="cart-upsell__inner"><p class="cart-upsell__text">' + txt + '</p></div></div>';
}

function dbcUpsellHtml(cart, isEmpty) {
  var ups = (dbcCfg().upsells || []).filter(function (u) {
    if (!u || !u.available) return false;
    return !(cart && cart.items && cart.items.some(function (it) { return it.product_id === u.id; }));
  });
  if (!ups.length) return '';
  return ups.map(function (u) {
    return '<div class="cart-upsell"><div class="cart-upsell__inner">' +
      (u.image ? '<img class="cart-upsell__img" src="' + u.image + '" alt="">' : '') +
      '<p class="cart-upsell__text">' + (isEmpty ? 'START WITH ' : 'ADD ') + '<strong>' + escapeHtml(u.title.toUpperCase()) + '</strong><small>' + formatMoney(u.price) + '</small></p>' +
      '<button class="cart-upsell__btn" data-quick-add="' + u.variant + '">+ ADD</button></div></div>';
  }).join('');
}

/* ── quick add (grid tiles, drop tile, cart upsells) ──────── */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-quick-add]'); if (!b) return;
  e.preventDefault(); e.stopPropagation();
  var id = parseInt(b.getAttribute('data-quick-add'), 10); if (!id) return;
  var label = b.textContent; b.textContent = '...'; b.classList.add('loading');
  dbcCartAdd([{ id: id, quantity: 1 }])
    .then(function () { b.textContent = label; b.classList.remove('loading'); })
    .catch(function (err) { b.textContent = label; b.classList.remove('loading'); dbcToast((err && err.description) || 'COULD NOT ADD'); });
});

/* ── bundle builder ───────────────────────────────────────── */
(function () {
  var builder = document.querySelector('[data-builder]'); if (!builder) return;
  var b = dbcCfg().bundle || { prices: {}, unit: 7500 };
  var items = Array.prototype.slice.call(builder.querySelectorAll('.builder__item'));
  var qtyEl = builder.querySelector('[data-b-qty]'), priceEl = builder.querySelector('[data-b-price]'), wasEl = builder.querySelector('[data-b-was]'), saveEl = builder.querySelector('[data-b-save]'), addBtn = builder.querySelector('[data-b-add]');
  var unit = parseInt(b.unit, 10) || 7500;
  function selected() { return items.filter(function (i) { return i.classList.contains('is-on'); }); }
  function update() {
    var n = selected().length;
    items.forEach(function (i) { i.classList.toggle('is-off', n >= 4 && !i.classList.contains('is-on')); });
    var tier = b.prices && b.prices[n] ? b.prices[n] * 100 : unit * n;
    if (qtyEl) qtyEl.textContent = n;
    if (priceEl) priceEl.textContent = dbcMoneyClean(n ? tier : 0);
    if (wasEl) wasEl.textContent = n > 1 && unit * n > tier ? dbcMoneyClean(unit * n) : '';
    if (saveEl) saveEl.textContent = n > 1 && unit * n > tier ? 'SAVE ' + dbcMoneyClean(unit * n - tier) : '';
    if (addBtn) addBtn.disabled = n < 2;
  }
  items.forEach(function (i) {
    var toggle = function () { if (i.classList.contains('is-off')) return; i.classList.toggle('is-on'); i.setAttribute('aria-pressed', i.classList.contains('is-on')); update(); };
    i.addEventListener('click', toggle);
    i.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
  });
  if (addBtn) addBtn.addEventListener('click', function () {
    var sel = selected(); if (sel.length < 2) return;
    addBtn.textContent = 'ADDING...'; addBtn.classList.add('loading');
    dbcCartAdd(sel.map(function (i) { return { id: parseInt(i.getAttribute('data-variant'), 10), quantity: 1 }; }))
      .then(function () { addBtn.textContent = 'ADD BUNDLE TO CART'; addBtn.classList.remove('loading'); })
      .catch(function (err) { addBtn.textContent = 'ADD BUNDLE TO CART'; addBtn.classList.remove('loading'); dbcToast((err && err.description) || 'COULD NOT ADD'); });
  });
  update();
})();

/* ── sticky add to cart (mobile) ──────────────────────────── */
(function () {
  var bar = document.getElementById('sticky-atc'), atc = document.getElementById('add-to-cart-btn');
  if (!bar || !atc || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    var en = entries[0];
    /* Chaz: the buy button is never off screen. The bar shows from load and hides only while the real ADD TO CART is in view. */
    var visible = en.isIntersecting && en.intersectionRatio >= 0.6; /* a sliver of the real button is not usable */
    bar.classList.toggle('is-visible', !visible); bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
    document.body.classList.toggle('has-sticky-atc', !visible);
  }, { threshold: [0, 0.6, 1] });
  io.observe(atc);
})();

/* ── the street: scale the stage to cover its box ─────────── */
(function () {
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function init(scene) {
    var stage = scene.querySelector('.scene__stage'); if (!stage) return;
    var sw = parseFloat(scene.getAttribute('data-stage-w')) || 3469, sh = parseFloat(scene.getAttribute('data-stage-h')) || 2172;
    var focusX = parseFloat(scene.getAttribute('data-focus-x')); if (isNaN(focusX)) focusX = 0.5;
    var focusY = parseFloat(scene.getAttribute('data-focus-y')); if (isNaN(focusY)) focusY = 0.5;
    var mobileZoom = parseFloat(scene.getAttribute('data-mobile-zoom')) || 1, desktopZoom = parseFloat(scene.getAttribute('data-desktop-zoom')) || 1;
    scene.style.setProperty('--stage-w', sw + 'px'); scene.style.setProperty('--stage-h', sh + 'px');
    function layout() {
      var cw = scene.clientWidth, ch = scene.clientHeight; if (!cw || !ch) return;
      var scale = Math.max(cw / sw, ch / sh) * (window.innerWidth < 768 ? mobileZoom : desktopZoom);
      var visW = cw / scale, visH = ch / scale;
      var maxX = Math.max(0, (sw - visW) / 2), maxY = Math.max(0, (sh - visH) / 2);
      scene.style.setProperty('--stage-scale', scale);
      scene.style.setProperty('--stage-x', (clamp((0.5 - focusX) * sw, -maxX, maxX) * scale).toFixed(2) + 'px');
      scene.style.setProperty('--stage-y', (clamp((0.5 - focusY) * sh, -maxY, maxY) * scale).toFixed(2) + 'px');
    }
    if (window.ResizeObserver) new ResizeObserver(layout).observe(scene); else window.addEventListener('resize', layout);
    layout();
    var stars = scene.querySelector('.scene__stars');
    if (stars && !stars.children.length) {
      var n = parseInt(scene.getAttribute('data-stars') || '36', 10), skyH = parseFloat(scene.getAttribute('data-sky-h')) || 400, frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var s = document.createElement('span'); s.className = 'scene__star';
        s.style.left = (Math.random() * 100) + '%'; s.style.top = ((20 + Math.random() * (skyH - 40)) / sh * 100) + '%';
        s.style.setProperty('--d', (2.5 + Math.random() * 4).toFixed(2) + 's'); s.style.setProperty('--delay', (-Math.random() * 6).toFixed(2) + 's');
        frag.appendChild(s);
      }
      stars.appendChild(frag);
    }
  }
  document.querySelectorAll('.scene[data-stage]').forEach(init);
})();

/* ── countdowns: generic [data-countdown] blocks ──────────── */
/* Password page, product drop gate and announcement bar. The runner lives in the
   drop timing block at the end of this file (dbcInitDropTiming), which also starts them. */

/* ── drop timing (dev-drop) ─────────────────────────────────
   Drops go live at 8pm UK. Theme settings > Current drop > Drop date and time
   takes UK wall clock time ("2026-10-25 20:00") and this reads it as
   Europe/London through Intl, so the GMT/BST switch (02:00 on Sun 25 Oct 2026,
   the drop day itself) cannot move a launch by an hour. A full ISO string with
   an offset or Z still works. snippets/drop-epoch.liquid does the same maths
   on the server for the no JS line and the product gate.

   [data-drop-time]  fills the MELBOURNE and YOUR TIME lines (snippets/drop-time)
   [data-countdown]  ticks DAYS : HRS : MIN : SEC, fires dbc:drop-live at zero
   [data-drop-swap]  at zero hides [data-drop-pre] and shows [data-drop-post]
   [data-drop-gate]  product coming soon state (snippets/drop-gate), reloads at zero
   ============================================================ */

var dbcZoneFmtCache = {};
function dbcZoneParts(ms, tz) {
  var fmt = dbcZoneFmtCache[tz] || (dbcZoneFmtCache[tz] = new Intl.DateTimeFormat('en-US', {
    timeZone: tz, hourCycle: 'h23', weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }));
  var o = {};
  fmt.formatToParts(new Date(ms)).forEach(function (p) { o[p.type] = p.value; });
  return { y: +o.year, mo: +o.month, d: +o.day, h: (+o.hour) % 24, mi: +o.minute, s: +o.second, wd: o.weekday };
}

/* Offset of a zone from UTC at an instant, in ms (London: 0 in GMT, 3600000 in BST). */
function dbcZoneOffsetMs(ms, tz) {
  var p = dbcZoneParts(ms, tz);
  return Date.UTC(p.y, p.mo - 1, p.d, p.h, p.mi, p.s) - Math.floor(ms / 1000) * 1000;
}

/* Wall clock time in a zone to an instant. Around a clock change it picks the
   earlier reading (BST) and, inside the spring gap, the pre change offset;
   same choices as snippets/drop-epoch.liquid. */
function dbcZoneWallToUtc(wall, tz) {
  var before = dbcZoneOffsetMs(wall - 432e5, tz), after = dbcZoneOffsetMs(wall + 432e5, tz);
  var a = wall - before, b = wall - after;
  if (a + dbcZoneOffsetMs(a, tz) === wall) return a;
  if (b + dbcZoneOffsetMs(b, tz) === wall) return b;
  return a;
}

/* "2026-10-25 20:00" / "2026-10-25T20:00" / "2026-10-25" (8pm) as UK time,
   or "2026-09-25T09:00:00+01:00" / "...Z" as given. Returns ms or NaN. */
function dbcParseDropDate(str) {
  if (str === null || str === undefined || str === '') return NaN;
  if (typeof str === 'number') return str < 1e12 ? str * 1000 : str;
  var s = String(str).trim();
  if (/^\d{9,10}$/.test(s)) return +s * 1000;
  var m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ]+(\d{2}):(\d{2})(?::(\d{2})(?:\.\d+)?)?)?\s*(Z|[+-]\d{2}:?\d{2})?$/i);
  if (!m) return NaN;
  var y = +m[1], mo = +m[2], d = +m[3];
  var h = m[4] === undefined ? 20 : +m[4], mi = m[5] === undefined ? 0 : +m[5], sec = m[6] === undefined ? 0 : +m[6];
  if (y < 2000 || mo < 1 || mo > 12 || d < 1 || d > 31 || h > 23 || mi > 59 || sec > 59) return NaN;
  var wall = Date.UTC(y, mo - 1, d, h, mi, sec);
  var off = m[7];
  if (off) {
    if (off.toUpperCase() === 'Z') return wall;
    var digits = off.slice(1).replace(':', '');
    var offMs = (+digits.slice(0, 2)) * 36e5 + (+digits.slice(2, 4)) * 6e4;
    return off.charAt(0) === '-' ? wall + offMs : wall - offMs;
  }
  try { return dbcZoneWallToUtc(wall, 'Europe/London'); } catch (e) { return NaN; }
}

/* "SUN 25 OCT, 8PM UK" style. */
function dbcFormatDropTime(ms, tz, suffix) {
  var months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  var p = dbcZoneParts(ms, tz);
  var clock = (p.h % 12 || 12) + (p.mi ? ':' + String(p.mi).padStart(2, '0') : '') + (p.h < 12 ? 'AM' : 'PM');
  return String(p.wd).toUpperCase() + ' ' + p.d + ' ' + months[p.mo - 1] + ', ' + clock + (suffix ? ' ' + suffix : '');
}

function dbcVisitorZone() {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return ''; }
}

function dbcDropTarget(el) {
  var t = dbcParseDropDate(el.getAttribute('data-date'));
  if (isNaN(t) && el.getAttribute('data-drop-at')) t = +el.getAttribute('data-drop-at') * 1000;
  return t;
}

function dbcFillDropTime(el) {
  var at = dbcDropTarget(el);
  if (isNaN(at)) return;
  var zone = dbcVisitorZone();
  try {
    var uk = el.querySelector('[data-drop-line="uk"]'), mel = el.querySelector('[data-drop-line="mel"]'), local = el.querySelector('[data-drop-line="local"]');
    if (uk) uk.textContent = dbcFormatDropTime(at, 'Europe/London', 'UK');
    if (mel) { mel.textContent = dbcFormatDropTime(at, 'Australia/Melbourne', 'MELBOURNE'); mel.hidden = false; }
    /* Same clock as London (Dublin, Lisbon) or Melbourne (Sydney, Hobart) adds nothing. */
    var mine = zone ? dbcZoneOffsetMs(at, zone) : null;
    var kind = 'other';
    if (mine === null || mine === dbcZoneOffsetMs(at, 'Europe/London')) kind = 'uk';
    else if (mine === dbcZoneOffsetMs(at, 'Australia/Melbourne')) kind = 'au';
    el.setAttribute('data-drop-zone', kind);
    if (local && kind === 'other') { local.textContent = dbcFormatDropTime(at, zone, 'YOUR TIME'); local.hidden = false; }
  } catch (e) { /* an unknown zone keeps the server UK line */ }
}

function dbcRunCountdown(el, target) {
  var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
  var sr = el.querySelector('[data-countdown-sr]'), lastMin = -1;
  function pad(n) { return String(n).padStart(2, '0'); }
  function set(a, b, c, e) { if (d) d.textContent = pad(a); if (h) h.textContent = pad(b); if (m) m.textContent = pad(c); if (s) s.textContent = pad(e); }
  (function tick() {
    var diff = target - Date.now();
    if (diff <= 0) {
      set(0, 0, 0, 0);
      el.classList.add('is-live');
      if (sr) sr.textContent = 'The drop is live.';
      el.dispatchEvent(new CustomEvent('dbc:drop-live', { bubbles: true, detail: { at: target } }));
      return;
    }
    var days = Math.floor(diff / 864e5), hrs = Math.floor(diff / 36e5) % 24, mins = Math.floor(diff / 6e4) % 60;
    set(days, hrs, mins, Math.floor(diff / 1e3) % 60);
    /* Screen reader copy changes once a minute and is not a live region, so it is never read out every second. */
    var totalMin = Math.floor(diff / 6e4);
    if (sr && totalMin !== lastMin) { lastMin = totalMin; sr.textContent = totalMin ? days + ' days, ' + hrs + ' hours, ' + mins + ' minutes to go.' : 'Under a minute to go.'; }
    setTimeout(tick, (diff % 1000) + 20);
  })();
}

/* One polite announcement at zero, from the nearest drop time block. */
function dbcAnnounceLive(from) {
  /* A swap box hides the countdown (and its live region) at zero, so it keeps its own region outside. */
  var swap = from.closest('[data-drop-swap]');
  var root = from.closest('[data-drop-time]') || from;
  var live = (swap && swap.querySelector('[data-swap-announce]')) || root.querySelector('[data-drop-announce]');
  if (live) { live.textContent = ''; setTimeout(function () { live.textContent = 'The drop is live.'; }, 60); }
}

function dbcInitDropGate() {
  var gate = document.querySelector('[data-drop-gate]');
  if (!gate) return;
  var page = document.getElementById('product-page');
  var at = +gate.getAttribute('data-drop-at');
  if (page) page.classList.add('is-drop-gated');
  document.body.classList.add('has-drop-gate');

  /* drop_live marks the one reload this page makes at zero; strip it from the address bar. */
  var flag = null;
  try {
    var url = new URL(window.location.href);
    flag = url.searchParams.get('drop_live');
    if (flag !== null) { url.searchParams.delete('drop_live'); history.replaceState(history.state, '', url.toString()); }
  } catch (e) {}

  function reloadLive() {
    try { var u = new URL(window.location.href); u.searchParams.set('drop_live', String(at)); window.location.replace(u.toString()); }
    catch (e) { window.location.reload(); }
  }
  /* Server still rendered the gate after our reload: a cached page or a fast clock.
     Open it here; admin (inventory / publish time) is the real gate anyway. */
  function openUp() {
    gate.hidden = true;
    if (page) page.classList.remove('is-drop-gated');
    document.body.classList.remove('has-drop-gate');
  }
  gate.addEventListener('dbc:drop-live', function () {
    var live = gate.querySelector('[data-drop-gate-live]'), notify = gate.querySelector('[data-drop-gate-notify]');
    if (live) live.hidden = false;
    if (notify) notify.hidden = true;
    gate.classList.add('is-live');
    if (flag === String(at)) { openUp(); return; }
    /* Do not wipe a half typed phone number; the LOAD THE DROP button is there instead. */
    var a = document.activeElement;
    if (a && gate.contains(a) && /^(INPUT|SELECT|TEXTAREA)$/.test(a.tagName)) return;
    /* Spread the reloads over a couple of seconds so every open tab does not hit at once. */
    setTimeout(reloadLive, Math.floor(Math.random() * 2500));
  });
  var btn = gate.querySelector('[data-drop-reload]');
  if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); reloadLive(); });
}

function dbcInitDropTiming() {
  document.querySelectorAll('[data-drop-time]').forEach(dbcFillDropTime);
  document.querySelectorAll('[data-drop-swap]').forEach(function (box) {
    box.addEventListener('dbc:drop-live', function () {
      box.querySelectorAll('[data-drop-pre]').forEach(function (x) { x.hidden = true; });
      box.querySelectorAll('[data-drop-post]').forEach(function (x) { x.hidden = false; });
    });
  });
  document.addEventListener('dbc:drop-live', function (e) { dbcAnnounceLive(e.target); });
  document.querySelectorAll('[data-pw-reload]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); window.location.reload(); });
  });
  dbcInitDropGate();
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = dbcDropTarget(el);
    if (!isNaN(target)) dbcRunCountdown(el, target);
  });
}

dbcInitDropTiming();

/* ── quick sizes on tiles (sized products): + ADD shows the sizes, a size adds it ── */
document.addEventListener('click', function (e) {
  var toggle = e.target.closest('[data-size-toggle]');
  if (toggle) {
    e.preventDefault();
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    var open = panel.hidden;
    document.querySelectorAll('.quick-sizes:not([hidden])').forEach(function (p) {
      p.hidden = true;
      var t = document.querySelector('[aria-controls="' + p.id + '"]');
      if (t) { t.setAttribute('aria-expanded', 'false'); t.textContent = '+ ADD'; }
    });
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.textContent = open ? 'CLOSE' : '+ ADD';
    if (open) { var first = panel.querySelector('button:not([disabled])'); if (first) first.focus(); }
    return;
  }
  var size = e.target.closest('.quick-sizes__btn');
  if (size) {
    /* the shared [data-quick-add] handler adds it; close the panel once it is in */
    var p = size.closest('.quick-sizes');
    setTimeout(function () {
      if (!p) return;
      p.hidden = true;
      var t = document.querySelector('[aria-controls="' + p.id + '"]');
      if (t) { t.setAttribute('aria-expanded', 'false'); t.textContent = '+ ADD'; }
    }, 600);
  }
});
document.addEventListener('keydown', function (e) {
  if (e.key === ' ' && e.target.matches && e.target.matches('a[data-size-toggle]')) { e.preventDefault(); e.target.click(); return; }
  if (e.key !== 'Escape') return;
  var p = document.querySelector('.quick-sizes:not([hidden])'); if (!p) return;
  p.hidden = true;
  var t = document.querySelector('[aria-controls="' + p.id + '"]');
  if (t) { t.setAttribute('aria-expanded', 'false'); t.textContent = '+ ADD'; t.focus(); }
});

/* ── cart pairing: a rug suggests the tees, a tee suggests the rugs ── */
/* Shown above the regular upsells in the drawer. Tees add by size, rugs add in one tap. */
function dbcPairHtml(cart) {
  var cfg = dbcCfg(), pool = cfg.dropPair || [];
  if (!cart || !cart.items || !cart.items.length || !pool.length) return '';
  var inCart = {}; cart.items.forEach(function (it) { inCart[it.product_id] = true; });
  var hasType = function (type) { return pool.some(function (p) { return p.type === type && inCart[p.id]; }); };
  var want = hasType('Rug') && !hasType('Tee') ? 'Tee' : hasType('Tee') && !hasType('Rug') ? 'Rug' : '';
  if (!want) return '';
  var picks = pool.filter(function (p) { return p.type === want && !inCart[p.id]; });
  if (!picks.length) return '';
  var cc = String(cfg.country || 'GB').toUpperCase(), sub = cart.items_subtotal_price || cart.total_price;
  var head = want === 'Tee' ? 'COMPLETE IT WITH A TEE' : 'ADD A RUG';
  var note = '';
  if (want === 'Tee') {
    /* UK free shipping starts at £100 and counts the whole cart, so a rug plus a tee ships free. */
    note = (cc === 'GB' && sub < 10000 && sub + 3500 >= 10000)
      ? 'ADD A TEE AND YOUR ORDER SHIPS FREE'
      : 'TEES SHIP FREE';
  }
  var tiles = picks.map(function (p) {
    var colour = p.title.split(' - ').pop().toUpperCase();
    var add;
    if (p.variants.length === 1) {
      add = '<button class="pair__add" data-quick-add="' + p.variants[0].id + '">+ ADD</button>';
    } else {
      add = '<div class="pair__sizes" role="group" aria-label="Sizes for ' + escapeHtml(p.title) + '">' + p.variants.map(function (v) {
        return '<button class="pair__size" data-quick-add="' + v.id + '"' + (v.available ? '' : ' disabled') + ' aria-label="Add ' + escapeHtml(p.title) + ' size ' + escapeHtml(v.label) + '">' + escapeHtml(v.label) + '</button>';
      }).join('') + '</div>';
    }
    return '<div class="pair__tile"><a href="' + p.url + '" class="pair__img">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy" width="120" height="120">' : '') + '</a>' +
      '<p class="pair__name">' + escapeHtml(colour) + ' <span>' + dbcMoneyClean(p.price) + '</span></p>' + add + '</div>';
  }).join('');
  return '<div class="pair"><p class="pair__head">' + head + (note ? '<span>' + note + '</span>' : '') + '</p><div class="pair__row">' + tiles + '</div></div>';
}


/* ── sized products: SELECT SIZE until a size is picked (main button, sticky bar, Shop Pay) ── */
(function () {
  var picker = document.querySelector('[data-variant-picker]');
  var btns = Array.prototype.slice.call(document.querySelectorAll('#add-to-cart-btn[data-needs-size], [data-sticky-atc][data-needs-size]'));
  if (!picker || !btns.length || /[?&]variant=/.test(location.search)) return;
  var form = document.getElementById('product-form');
  var chosen = false;
  /* Nothing looks picked on load in the rows that need a choice. */
  picker.querySelectorAll('.variant-group:not([hidden]) .variant-btn').forEach(function (b) {
    b.classList.remove('selected'); b.setAttribute('aria-pressed', 'false');
  });
  btns.forEach(function (b) { if (!b.disabled) b.textContent = 'SELECT SIZE'; });
  if (form) form.setAttribute('data-needs-size', '');
  /* Capture phase: runs before the buttons' own add to cart. */
  document.addEventListener('click', function (e) {
    if (chosen || btns.indexOf(e.target) < 0) return;
    e.preventDefault(); e.stopPropagation();
    picker.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    picker.classList.add('needs-size');
    setTimeout(function () { picker.classList.remove('needs-size'); }, 1600);
  }, true);
  picker.addEventListener('click', function (e) {
    var b = e.target.closest('.variant-btn'); if (!b || b.getAttribute('aria-disabled') === 'true') return;
    var g = b.closest('.variant-group'); if (!g || g.hidden) return;
    chosen = true;
    if (form) form.removeAttribute('data-needs-size');
    btns.forEach(function (x) { if (!x.disabled) x.textContent = 'ADD TO CART'; });
  });
})();

/* Menu drop link: close the phone menu so the jump to the drop rows is visible. */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('.mobile-nav__link--drop'); if (!a) return;
  var ov = document.getElementById('mobile-menu-overlay');
  if (ov && ov.classList.contains('is-open') && typeof toggleMobileMenu === 'function') toggleMobileMenu();
});
